export default __webpack_public_path__ + "locales/en/DeleteDialog.json?hash=9117bde8405f26d821d8378d700c1679";